// GENERAL
export const BRDGE_PROJECT_ID = "wdd" // can be any string, will be used to namespace cookies (so that two "brdge projects" seamlessly work without clearing cookies)

// LOCALES
export const AVAILABLE_LOCALES = ["de"]
export const DEFAULT_LOCALE = "de"

// MISC
const OVERRIDE_TO_REMOVE_DELAY = false // Use this to play the game without ANY delays ANYWHERE (for testing purposes)
export const WITH_DELAY =
  import.meta.test || import.meta.dev ? !OVERRIDE_TO_REMOVE_DELAY : true
